export default __webpack_public_path__ + "static/media/plain-sticker-U.69cdabb3.png";